import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  isBetaUser: false,
  isAdmin: false,
  isLoading: true, // Track loading state while checking auth
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      // Only store serializable user data (not the full Firebase User object)
      const { uid, email, displayName, photoURL } = action.payload;
      state.user = { uid, email, displayName, photoURL };
      state.isAuthenticated = true;
      state.isLoading = false;
    },
    setBetaStatus: (state, action) => {
      // Beta status comes from secure server-side custom claims
      state.isBetaUser = action.payload;
    },
    setAdminStatus: (state, action) => {
      // Admin status comes from secure server-side custom claims
      state.isAdmin = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.isBetaUser = false;
      state.isAdmin = false;
      state.isLoading = false;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setBetaStatus, setAdminStatus, clearUser, setLoading } = authSlice.actions;

export default authSlice.reducer;
